import { useEffect } from "react"
import "../../styles/reception.scss"
import "../../styles/umbrella.scss"
import { Menu } from "../components/Menu"
import { Template } from "../components/Template"
import { useScrollAnimation } from "../hooks/useScrollAnimation"
import type { TemplateProps } from "../types"

export function UmbrellaTemplate({ title, children }: TemplateProps) {
  useEffect(() => {
    document.title = title
  }, [title])

  useScrollAnimation({
    elementId: "umbrella",
    transformFn: (percent) => `translate3d(-55%,-52%, 0) rotate(${-(percent * 60)}deg)`,
  })

  return (
    <Template className="umbrellaTemplate">
      <div id="beach"></div>
      <div id="umbrella"></div>
      <Menu />
      <div className="content">
        <article>{children}</article>
      </div>
    </Template>
  )
}
